"use client";

import Tetris from "@/components/Tetris.component";

export default function TetrisPage() {
  return (
    <div className="container h-dvh overflow-hidden">
      <Tetris />
    </div>
  );
}